import { ContentLoader } from './ContentLoader.styled';

export default ContentLoader;
